import { type Consumer, createConsumer } from "@rails/actioncable"

let consumer: Consumer | null = null

export function getCableConsumer() {
  if (typeof window === "undefined") {
    return null
  }

  consumer ??= createConsumer()

  return consumer
}
